const isDevelopment = process.env.NODE_ENV === 'development';

export const logger = {
  log: (...args) => {
    if (isDevelopment) {
      console.log('[TasksV2]', ...args);
    }
  },

  info: (...args) => {
    if (isDevelopment) {
      console.info('[TasksV2]', ...args);
    }
  },

  warn: (...args) => {
    if (isDevelopment) {
      console.warn('[TasksV2]', ...args);
    }
  },

  error: (...args) => {
    // Always log errors, even in production
    console.error('[TasksV2]', ...args);
  },

  debug: (...args) => {
    if (isDevelopment) {
      console.debug('[TasksV2]', ...args);
    }
  },
};
